import type { Environment } from '@sg/common';
import { oidcUriNormalizer } from '../utils';
import type { SgApplicationConfiguration } from './types';

const PATHNAME_DETECT_REGEXP = new RegExp(`^(?:#\\/|#|\\/)(sg-admin)(?:(?:\\/|\\?|\\().*)?$`);
const HOSTNAME_DETECT_REGEXP = new RegExp(`^admin(?:-.*)?\\.sharegain\\.com$`);

declare module '@sg/pre-app-init/src/lib/application' {
  export interface SgCustomAppBranding {
    'sg-admin': {
      congratulationsIcon: string;
      paymentIcon: string;
      checkFlyIcon: string;
      checkFlyIconPrimaryColor: string;
      errorIcon: string;
      adminProdLogo: string;
    }
  }
}

export const sgAdmin: SgApplicationConfiguration<'sg-admin'> = {
  name: 'sg-admin',
  matcher: (location: Location) => {
    return PATHNAME_DETECT_REGEXP.test(location.pathname) 
      || PATHNAME_DETECT_REGEXP.test(location.hash)
      || HOSTNAME_DETECT_REGEXP.test(location.hostname);
  },
  authType: 'oidc',
  branding: {
    favIcon: 'assets/sg-admin/images/favicon.ico',
    logo: 'assets/images/sharegain-logo-horizontal-black-on-white.svg',
    preLogo: 'assets/images/sharegain-logo-horizontal-black-on-white.svg',
    custom: {
      congratulationsIcon: 'assets/sg-admin/images/congratulations-icon.svg',
      paymentIcon: 'assets/sg-admin/images/payment-icon.svg',
      checkFlyIcon: 'assets/sg-admin/images/check-fly-icon.svg',
      checkFlyIconPrimaryColor: 'assets/sg-admin/images/check-fly-icon-primary-color.svg',
      errorIcon: 'assets/sg-admin/images/error-icon.svg',
      adminProdLogo: 'assets/images/white-sharegain-logo.svg',
    }
  },
  beforeLogin(env: Environment) {
    const { oidc } = env;
    env.oidc.acr_values = 'tenant:Admin idp:aad';

    // by default, OIDC redirects are set under the assumption of a path app (hostname.com/SG-APPNAME)
    // when it's not the case we need to set the redirects properly.
    if (!PATHNAME_DETECT_REGEXP.test(location.pathname) && !PATHNAME_DETECT_REGEXP.test(location.hash)) {
      oidcUriNormalizer(oidc);
    }
  },
}
